import { AstraAvatar, AstraAvatarProps } from '~/astra'
import { useStore } from '~/store/store'
import { getInitials } from '~/utils/user'

export const UserAvatar = (props: Partial<Omit<AstraAvatarProps, 'variant'>>) => {
    const userDisplayName = useStore(state => state.user.display_name)
    const initials = getInitials(userDisplayName || '')

    return <AstraAvatar initials={initials} variant="initial" useColorGenerator {...props} />
}
